export default "__VITE_ASSET__CShymoFB__"